<template>
  <div>
    <p class="small text-muted mb-3">可點選文字內容進行修正</p>

    <textarea
      v-model="text"
      spellcheck="true"
      class="form-control mb-3"
      style="height: 16rem; resize: none;"
    ></textarea>

    <p class="small text-muted text-center mb-3">
      AI 辨識文字結果會因字跡整齊、紙張整潔或照片清晰度之影響而有所不同，請務必重新檢視一遍並進行修正再確認上傳文章。
    </p>

    <div class="mt-4 d-flex justify-content-end">
      <button @click="$emit('toStepNum', 1)" class="btn btn-outline-secondary mr-2 py-2 px-4">重新上傳圖片</button>
      <button @click="finish()" class="btn btn-primary bg-blue-main py-2 px-4">輸入</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recognizedText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      text: this.recognizedText
    }
  },
  watch: {
    recognizedText(newVal) {
      this.text = newVal
    }
  },
  methods: {
    finish() {
      this.$emit('finish', this.text)
    }
  }
}
</script>

  <style scoped>
  .bg-brown {
    background-color: #8c5a42;
  }
</style>
